<template>
  <div class="business-house">
    <el-dialog title="选择房间" visible :before-close="close" :close-on-click-modal="false">
      <div class="house-select-form">
        <el-form inline ref="houseSelectData" :rules="rules" :model="houseSelectData" label-width="112px" label-position="right">
          <el-row>
            <el-col :span="12">
              <el-form-item class="half-line" label="门店名" prop="zoneId">
                <el-select class="half-item" :disabled="houseSelectData.isSelected" @change="getBlockList" v-model="houseSelectData.zoneId" placeholder="请选择门店">
                  <el-option v-for="(item, index) in zoneList" :key="index" :label="item.name" :value="item.id">

                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item class="half-line" label="小区/社区名字" prop="blockId">
                <el-select class="half-item" :disabled="houseSelectData.isSelected" @change="getBuildingList" v-model="houseSelectData.blockId" :no-data-text='loadingText' placeholder="请选择社区/小区">
                  <el-option v-for="(item, index) in blockList" :key="index" :label="item.blockName" :value="item.blockId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item class="half-line" label="楼栋数" prop="buildingNo">
                <el-select @change="getHouseList" class="half-item" v-model="houseSelectData.buildingNo" placeholder="请选择楼栋">
                  <el-option v-for="(item, index) in buildingList" :key="index" :label="item.buildingNo" :value="item.buildingNo"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item class="half-line" label="输入房号搜索">
                <el-input @input="searchHouseList" class="half-item" v-model="houseSelectData.roomNo" placeholder="请输入要查询的房号"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="separate-line"></el-row>
          <el-row>选择了<span style="color: #3CBFC4">{{houseSelectedNumber()}}</span>间房<span class="house-change-word">以下仅展示系统空置的房源及该租客的预订房源</span></el-row>
          <div class="house-list">
            <div class="house-item" v-for="(item, index) in houseList" :class="wideBorder(item, index)" :key="index" @click="isSelected(item, index)">
              <p class="item-title">{{roomName(item)}}</p>
              <p class="item-price">{{item.expectedRentalPrice / 1000}}元/月</p>
              <p class="item-status" :class="wordColor(item)">{{item.houseSpaceStatus | houseSpaceStatus}}</p>
            </div>
          </div>
          <div class="load-more" v-if="ifShowLordMore">
            <el-button @click="loadMore">查看更多</el-button>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirm('houseSelectData')">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { houseSpaceStatus } from './enum.js'
import accountApi from '@/xhr/services/account.js'
import houseApi from '@/xhr/services/house'
import rentApi from '@/xhr/services/rent'
import calendar from 'solarday2lunarday'
import Lunar from '../../common/lunar2solar'

export default {
  data () {
    return {
      rules: {
        zoneId: [{ required: true, message: '请选择门店名', trigger: 'change' }],
        blockId: [{ required: true, message: '请选择小区/社区名字', trigger: 'change' }],
        buildingNo: [{ required: true, message: '请选择楼栋数', trigger: 'change' }],
      },
      houseTotalList: [],
      houseList: [], // 选择的房源列表
      userPhone: this.$store.state.currentUser.UserPhone,
      zoneList: [],
      blockList: [],
      buildingList: [],
      loadingText: '无数据',
      selectedArr: [],
      isCheck: false,

      getBlock: {}
    }
  },
  props: {
    tenantId: {
      type: String,
      default: '',
    },
    houseListNum: {
      type: Array,
      default: () => {
        return []
      },
    },
    houseSelectData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    timeRange: {
      type: String,
      default: '',
    },
    tzEndTime: {
      type: Date
    }
  },
  computed: {
    ifShowLordMore () {
      if (this.houseList.length === this.houseTotalList.length) {
        return false
      }
      return true
    },
  },
  watch: {
    houseList (val, oldValue) {
      if (val.length === 0) {
        this.selectedArr = []
      }
    },
    zoneList (val) {
      if (val.length) {
        let hasZone = val.filter(item => item.id === this.houseSelectData.zoneId).length
        let hasSuiYu = val.filter(item => item.id === '3e2fe4faa399476786dda82bde78052c')
        let isSelected = this.houseSelectData.isSelected
        if (!hasZone && hasSuiYu && isSelected) {
          this.houseSelectData.zoneId = '3e2fe4faa399476786dda82bde78052c'
        } else if (!hasZone && !hasSuiYu && isSelected) {
          this.$message.warning('片区获取异常')
          this.houseSelectData.zoneId = ''
        }
      }
    }
  },
  methods: {
    evadeSpringFestival(val) {
      let zoneId = this.houseSelectData.zoneId
      if (['af685d406c514f6099f2c397e3b4cdee', '765c5374c04740c19c325458fe66bbaa', '6d3602e21f094d8788500da31b62c967'].includes(zoneId)) {
        return true;
      }
      // 考虑到如果阳历日期对应农历在同一年
      // 假如 退租时间 阳历是2023年12月30号 =  农历2023年12月17日  只对比2022年农历12月16日 到 2023年农历1月5日
      // 这样就会出现遗漏 修复 对比去年到今年 也对比今年到明年 钉钉同样
      let year = new Date(val).getFullYear() // 获取退租时间的年份
      // let lastyeartime = Lunar.toSolar(year - 1, 12, 16) // 获取上一年十二月16日 的阳历日期 格式 [year, month, day]
      let theyeartime = Lunar.toSolar(year, 1, 5) // 获取当年一月5日  的阳历日期 格式 [year, month, day]
      // let lasttheyeartime = Lunar.toSolar(year, 12, 16) // 获取今年十二月16日 的阳历日期 格式 [year, month, day]
      let thetomyeartime = Lunar.toSolar(year + 1, 1, 5) // 获取明年一月5日  的阳历日期 格式 [year, month, day]
      const { solarYear, solarMonth, solarDay } = calendar.lunar2solar(
        year - 1,
        12,
        16,
        false
      )
      const startTime = new Date(
        `${solarYear}-${solarMonth}-${solarDay}`
      ).getTime()
      // const startTime = new Date(`${lastyeartime[0]}-${lastyeartime[1]}-${lastyeartime[2]}`).getTime() // 获取开始时间戳
      const endTime = new Date(
        `${theyeartime[0]}-${theyeartime[1]}-${theyeartime[2]}`
      ).getTime() // 获取结束时间戳
      const {
        solarYear: solarYear1,
        solarMonth: solarMonth1,
        solarDay: solarDay1,
      } = calendar.lunar2solar(year, 12, 16, false)
      const startTime1 = new Date(
        `${solarYear1}-${solarMonth1}-${solarDay1}`
      ).getTime()
      // const startTime1 = new Date(`${lasttheyeartime[0]}-${lasttheyeartime[1]}-${lasttheyeartime[2]}`).getTime() // 获取开始时间戳
      const endTime2 = new Date(
        `${thetomyeartime[0]}-${thetomyeartime[1]}-${thetomyeartime[2]}`
      ).getTime() // 获取结束时间戳
      console.log({ startTime, endTime })
      console.log({ startTime1, endTime2 })
      // 2025-02-08
      // 暂时关闭签约结束时间落再过年期间限制
      // 2025-03-24
      // 打开签约结束时间落再过年期间限制
      // 2026-01-04
      // 暂时关闭签约结束时间落再过年期间限制
      // if (startTime <= Number(val) && Number(val) <= endTime) {
      //   this.$message('合同结束时间不符合规定，请重新选择签约周期')
      //   return false
      // } else if (startTime1 <= Number(val) && Number(val) <= endTime2) {
      //   this.$message('合同结束时间不符合规定，请重新选择签约周期')
      //   return false
      // } else {
        return true
      // }
    },
    close () {
      let val = 'houseSelect'
      this.$emit('closeAddCompany', val)
    },
    // 标记文字颜色
    wordColor (item, index) {
      if (item.houseSpaceStatus === 'RENTABLE') {
        return 'status-red'
      } else if (item.houseSpaceStatus === 'RESERVED') {
        return 'status-orange'
      }
    },
    // 标记 是否选取房源的border颜色
    wideBorder (item, index) {
      const selected = this.selectedArr[index] === true
      // console.log(item, index, this.selectedArr[index])
      if (item.houseSpaceStatus === 'RENTABLE' && !selected) {
        return 'item-empty-unSelected'
      } else if (item.houseSpaceStatus === 'RESERVED' && !selected) {
        return 'item-reserved-unSelected'
      } else if (item.houseSpaceStatus === 'RENTABLE' && selected) {
        return 'item-empty-selected'
      } else if (item.houseSpaceStatus === 'RESERVED' && selected) {
        return 'item-reserved-selected'
      }
    },
    // 点击 选择房源函数
    isSelected (item, index) {
      this.selectedArr[index] = !this.selectedArr[index]
      this.$forceUpdate()
    },
    // 根据 loginId 获取 其所在门店接口
    getZoneList () {
      let userPhone = this.userPhone
      accountApi.getUserInfoOfZone(userPhone).then(res => {
        console.log(res)
        if (
          res.data.code === 200 &&
          res.data.data.unitBeans &&
          res.data.data.unitBeans.length
        ) {
          this.zoneList = res.data.data.unitBeans
        } else {
          this.zoneList = []
          this.$message.warning('暂未获得门店列表')
        }
      })
    },
    // 根据 zoneId 获取 小区列表
    getBlockList (id) {
      if (!this.houseSelectData.isSelected) {
        this.resetZone()
      }
      this.blockListSet()
    },
    // 根据片区Id 获取小区列表参数
    blockListSet () {
      if (!this.houseSelectData.zoneId) {
        return
      }
      // 社区时间校验why
      if (!this.evadeSpringFestival(this.tzEndTime)) {
        return
      }
      this.loadingText = '正在加载...'
      let params = {
        baseDateInfo: 'BLOCK',
        loginId: this.$store.state.currentUser.uid,
        zoneId: this.houseSelectData.zoneId,
      }
      houseApi.getBlockListByZoneId(params).then(res => {
        if (res.data.code === 200 && res.data.data && res.data.data.length) {
          this.blockList = res.data.data
          this.loadingText = '无数据'
        } else {
          this.loadingText = '无数据'
          this.blockLoading = false
          this.blockList = []
          this.$message.warning('暂未获得小区列表')
        }
      })
    },
    // 获取 楼栋数据
    getBuildingList (val) {
      if (val) {
        // let item = this.blockList.find(el => el.blockId === val)
        // const arr = ['40e010b52bd340f9ab7940279936f13e', 'b087d85df08b40d09e655e597eff39f9', 'c8b8d094afeb47b2b81d381f720ba354', '797fccc9c1304d299f7ac874ab53a61a']
        // if (item && this.timeRange === '6' && arr.includes(item.parentUnitId)) {
        //   this.$message.error('所选小区租期时长不能为6个月');
        //   this.houseSelectData.blockId = ''
        //   this.resetBlock()
        //   return
        // }
        this.resetBlock()  // 重置其他参数
        this.buildingListSet()
      }
    },
    buildingListSet () {
      if (!this.houseSelectData.blockId) {
        return
      }
      let params = {
        baseDateInfo: 'BUILDIND_NO',
        loginId: this.$store.state.currentUser.uid,
        blockId: this.houseSelectData.blockId,
      }
      houseApi.getBlockListByZoneId(params).then(res => {
        if (res.data.code === 200 && res.data.data && res.data.data.length) {
          this.buildingList = res.data.data
          this.buildingList.forEach(item => {
            item.buildingName = item.buildingNo
          })
        } else {
          this.buildingList = []
          this.$message.warning('暂未获得楼栋列表')
        }
      })
    },
    // 获取可选房源列表
    getHouseList () {
      let {
        zoneId,
        blockId,
        buildingNo,
        roomNo,
        loginId,
      } = this.houseSelectData
      if (zoneId && blockId && buildingNo && this.tenantId) {
        let params = {
          zoneId,
          blockId,
          buildingNo,
          roomNo,
          loginId,
          tenantId: this.tenantId,
        }
        houseApi.setReserved(params).then(res => {
          if (res.data.code === 200 && res.data.data && res.data.data.length) {
            this.houseTotalList = res.data.data
            if (res.data.data.length > 10) {
              this.houseList = res.data.data.slice(0, 10)
            } else {
              this.houseList = res.data.data
            }
          } else {
            this.houseTotalList = []
            this.houseList = []
          }
          this.setSelectArr(this.houseTotalList)
        })
      }
    },
    // 房间号实时搜索
    searchHouseList (val) {
      let str = this.houseSelectData.roomNo
      this.houseSelectData.roomNo = str.replace(/^\s*|\s*$/g, '')
      this.getHouseList() // 重新获取 房源列表
    },
    // 设置 一个数组记录 每个房间的选取状态
    setSelectArr (arr) {
      if (arr && arr.length) {
        this.selectedArr = [] // 清空状态数组
        arr.forEach((item, index) => {
          let isSelected = false
          this.selectedArr.push(isSelected)
        })
      }
    },
    // 获取已选择房间数
    houseSelectedNumber () {
      let selectedNumber = this.selectedArr.filter(item => item)
      return selectedNumber.length
    },
    // 房间名称
    roomName (item) {
      if (item.rentType === 'ENTIRE_RENT') {
        return `${item.buildingNo}栋${item.roomNo}`
      } else if (item.rentType === 'JOINT_RENT') {
        return `${item.buildingNo}栋${item.roomNo}${item.houseSpaceName}`
      }
    },
    // 更换小区后重置函数
    resetBlock () {
      this.houseSelectData.buildingNo = ''
      this.houseSelectData.roomNo = ''
      this.houseList = []
      this.houseTotalList = []
      this.selectedArr = []
      this.buildingList = []
    },
    // 更换门店后的重置函数
    resetZone () {
      this.houseSelectData.blockId = ''
      this.houseSelectData.buildingNo = ''
      this.houseSelectData.roomNo = ''
      this.houseList = []
      this.houseTotalList = []
      this.selectedArr = []
      this.blockList = []
      this.buildingList = []
    },
    // 点击查看更多
    loadMore () {
      this.houseList = this.houseTotalList
    },
    // 确认选择
    confirm (val) {
      this.$refs[val].validate((valid) => {
        if (valid) {
          let selectedNum = this.houseSelectedNumber()
          if (!selectedNum) {
            this.$message.warning('请先选择房间')
            return
          }
          let selectedList = []  // 已选择房源
          this.selectedArr.forEach((item, index) => {
            if (item === true) {
              let selectedHouse = this.houseList[index]
              selectedList.push(selectedHouse)
            }
          })
          // 判断所选房源是否有已预订房源, 有的话，调用租约接口获取预定id
          let reserveArr = selectedList.filter(item => item.houseSpaceStatus === 'RESERVED')
          if (reserveArr.length) {
            this.getReservationByUserId(resArr => {
              selectedList.forEach(item => {
                let selected = resArr.filter(kip => kip.houseSpaceId === item.houseSpaceId)
                if (selected && selected.length) {
                  item.reservationId = selected[0].reservationId
                } else {
                  item.reservationId = undefined
                }
              })
              let val = 'houseSelect'
              this.$emit('getHouseList', selectedList)
              this.$emit('closeAddCompany', val)
            })
          } else {
            let val = 'houseSelect'
            this.$emit('getHouseList', selectedList)
            this.$emit('closeAddCompany', val)
          }
        }
      })
    },
    // 根据 租客id 获取 已预订房源信息
    getReservationByUserId (callback) {
      if (this.tenantId) {
        rentApi.getReservationByUserId(this.tenantId).then(res => {
          let data = res.data
          if (data.code === 200 && data.data && data.data.length) {
            let reservedArr = []
            data.data.forEach(item => {
              let obj = {}
              obj.houseSpaceId = item.houseSpaceId
              obj.reservationId = item.reservationId
              obj.earnest = item.earnest
              reservedArr.push(obj)
            })
            callback(reservedArr)
            // console.log(reservedArr)
            // Promise.resolve(reservedArr)
          } else {
            callback([])
            // Promise.reject([])
          }
        })
      }
    }
  },
  filters: {
    houseSpaceStatus,
  },
  created () {
    this.houseList = this.houseListNum // 页面打开后，先将传入的房源信息传递给页面绑定的数组
    this.getZoneList()

    if (this.houseSelectData.zoneId) {
      this.blockListSet()
    }
    if (this.houseSelectData.blockId) {
      this.buildingListSet()
    }
    this.setSelectArr()
    // 监听bus事件
    // this.$root.bus.$on('zoneAndBlock', val => {
    //   let { zone, block } = val
    //   this.getZone = zone
    //   this.getBlock = block
    //   this.houseSelectData.zoneId = zone.id
    //   console.log(this.getZone)
    // })
  },
  // beforeDestory() {
  //   this.$root.bus.$off('zoneAndBlock')
  // }
}
</script>
<style lang="scss" scoped>
.business-house {
  .house-select-form {
    .half-line {
      width: 100%;
      .half-item {
        width: 100%;
      }
    }
    .separate-line {
      height: 0;
      border-bottom: 1px solid #e0e0e0;
      margin-bottom: 20px;
    }
    .house-change-word {
      margin-left: 20px;
      display: inline-block;
      color: #fbb13f;
    }
    .house-list {
      margin-top: 10px;
      .house-item {
        width: 140px;
        height: 85px;
        box-sizing: border-box;
        border-radius: 4px;
        display: inline-block;
        padding-top: 8px;
        padding-left: 13px;
        border: 2px solid;
        border-left: 4px solid;
        margin-right: 15px;
        margin-bottom: 20px;
        &:nth-child(5n) {
          margin-right: 0;
        }
        .item-title {
          font-size: 15px;
          line-height: 15px;
          margin-bottom: 10px;
          font-weight: 500;
          color: #333333;
        }
        .item-price {
          font-size: 14px;
          line-height: 14px;
          color: #666666;
          margin-bottom: 12px;
        }
        .item-status {
          font-size: 14px;
          line-height: 14px;
        }
        .status-red {
          color: #e52d2d;
        }
        .status-orange {
          color: #fbb13f;
        }
      }
      // 空置未选取
      .item-empty-unSelected {
        border: 2px solid #c0ccda;
        // border-left: 4px solid #e52d2d;
      }
      // 已预订未选取
      .item-reserved-unSelected {
        border: 2px solid #c0ccda;
        // border-left: 4px solid #fbb13f;
      }
      // 空置已选取
      .item-empty-selected {
        border: 2px solid #e52d2d;
        // border-left: 4px solid #e52d2d;
      }
      // 已预订已选取
      .item-reserved-selected {
        border: 2px solid #fbb13f;
        // border-left: 4px solid #fbb13f;
      }
      .isRed {
        border-color: red;
      }
      .isGreen {
        border-color: green;
      }
    }
    .load-more {
      text-align: center;
    }
  }
}
</style>
<style>
.business-house .el-dialog {
  width: 800px !important;
}
.business-house .el-input__icon + .el-input__inner {
  padding-right: 10px;
}
.business-house .half-line .el-form-item__content {
  width: 60%;
}
</style>



// WEBPACK FOOTER //
// src/components/forms/BusinessContractForm/businessHouseSelect.vue